export const SIGN_IN_METHODS = {
  PASSWORD: 'password',
  FACEBOOK: 'facebook.com',
  APPLE: 'apple.com'
}
